import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TuiTextfieldControllerModule, TuiInputModule } from '@taiga-ui/legacy';
import { TuiAvatar, TuiBadgedContent, TuiBadgeNotification } from '@taiga-ui/kit';
import {
  TuiDataList,
  TuiScrollbar,
  TuiScrollable,
  TuiDropdown,
  TuiIcon,
  TuiButton,
  TuiHint,
  TuiInitialsPipe,
  TuiAutoColorPipe,
} from '@taiga-ui/core';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '@src/app/components';
import { IconModule } from '@src/app/modules/icon';
import { ActionsModule } from '@src/app/modules/actions';
import { SharedModule } from '@src/app/shared';
import { EmojiModule } from '@src/app/modules/internal-messenger/emoji';
import { SearchUsersModule } from '@src/app/modules/search-users';

import { MessageModule } from '../message';
import { AttachmentModule } from '../attachment';
import { PipesModule } from '../pipes';
import { MessageInputModule, MessengerPhotoModule } from '../components';

import { ChatsListComponent } from './chats-list/chats-list.component';
import { ChatsListItemComponent } from './chats-list-item/chats-list-item.component';
import { ChatComponent } from './chat/chat.component';
import { ChatHeaderComponent } from './chat-header/chat-header.component';
import { ChatInputBoxComponent } from './chat-input-box/chat-input-box.component';
import { ChatDetailsComponent } from './chat-details/chat-details.component';
import { ChatDetailsHeaderComponent } from './chat-details-header/chat-details-header.component';
import { ChatDetailsItemComponent } from './chat-details-item/chat-details-item.component';
import { ChatAdministrationsListComponent } from './chat-administrations-list/chat-administrations-list.component';
import { ChatMembersListComponent } from './chat-members-list/chat-members-list.component';
import { ChatMembersListItemComponent } from './chat-members-list-item/chat-members-list-item.component';
import { ChatFooterComponent } from './chat-footer/chat-footer.component';
import { ChatEditFormComponent } from './chat-edit-form';
import { ChatCreateFormComponent } from './chat-create-form';
import { ChatAccessingDialogComponent } from './chat-accessing-dialog';

@NgModule({
  declarations: [
    ChatsListComponent,
    ChatsListItemComponent,
    ChatComponent,
    ChatInputBoxComponent,
    ChatHeaderComponent,
    ChatDetailsComponent,
    ChatDetailsHeaderComponent,
    ChatAdministrationsListComponent,
    ChatMembersListComponent,
    ChatDetailsItemComponent,
    ChatMembersListItemComponent,
    ChatFooterComponent,
    ChatEditFormComponent,
    ChatCreateFormComponent,
    ChatAccessingDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ComponentsModule,
    IconModule,
    TuiAvatar,
    TuiButton,
    ...TuiDropdown,
    TuiScrollbar,
    TuiScrollable,
    TuiTextfieldControllerModule,
    ...TuiDataList,
    TuiIcon,
    ...TuiBadgedContent,
    TuiBadgeNotification,
    MessageModule,
    AttachmentModule,
    ActionsModule,
    TranslateModule,
    SharedModule,
    EmojiModule,
    ...TuiHint,
    TuiInputModule,
    PipesModule,
    SearchUsersModule,
    TuiInitialsPipe,
    TuiAutoColorPipe,
    MessageInputModule,
    MessengerPhotoModule,
  ],
  exports: [ChatsListComponent, ChatComponent],
})
export class ChatModule {}
